import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinpurandar() {



  const cardData =
  {
    keyword: 'Bus On Rent in Purandar',
    heading: 'Sanavi Travels: Bus On Rent in Purandar',
    headingDescription: 'Sanavi Travels offers reliable Bus On Rent in Purandar, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, school excursions, weddings, and tourist travel in and around Purandar. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures smooth rides, ample seating, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip bus rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Purandar, Pune, and nearby areas, making it ideal for local sightseeing, outstation trips, corporate events, and group tours. Choose Sanavi Travels for trusted bus rental services in Purandar, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Purandar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Purandar Fort",
    "description": "Purandar Fort is a majestic hill fort located in Pune district, steeped in Maratha history. It is famously associated with Chhatrapati Shivaji Maharaj, who used it as a strategic military base. The fort is divided into two parts – Old Purandar and New Purandar – and offers panoramic views of the Sahyadri ranges, valleys, and surrounding villages. Its ancient gates, temples, and bastions attract history enthusiasts, trekkers, and photographers alike."
  },
  {
    "title": "Mahalaxmi Temple at Purandar",
    "description": "The fort complex houses the Mahalaxmi Temple, a spiritual center for devotees. Pilgrims visiting the fort often offer prayers here, combining spiritual exploration with trekking and sightseeing. The temple’s serene ambiance amidst the fort’s historic ruins adds to the cultural richness of the visit."
  },
  {
    "title": "Trekking Routes to Purandar Fort",
    "description": "Purandar Fort is one of the most popular trekking destinations near Pune. Trekkers can choose multiple routes from nearby villages like Saswad, Purandar, and Bhuleshwar. The trails pass through lush greenery, streams, and rocky terrain, making it ideal for adventure enthusiasts and nature lovers."
  },
  {
    "title": "Jafarabad Fort",
    "description": "Located within the Purandar region, Jafarabad Fort is part of the historical network of forts used by the Marathas. It offers a glimpse into military architecture, strategic watchtowers, and panoramic hilltop views that complement the Purandar trekking experience."
  },
  {
    "title": "Purandar Taluka Villages",
    "description": "The villages surrounding Purandar Fort reflect authentic rural Maharashtrian life, with farms, traditional houses, and local markets. Visitors can experience the cultural fabric of the region, local festivals, and farm-to-table cuisine."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "Bhuleshwar Temple, situated near Purandar, is an ancient temple dedicated to Lord Shiva. Its architecture, carvings, and tranquil surroundings attract both devotees and tourists seeking spiritual solace amidst nature."
  },
  {
    "title": "Monsoon Waterfalls",
    "description": "During the monsoon, the Purandar region comes alive with seasonal waterfalls, flowing streams, and mist-covered hills. These natural sights offer refreshing stops during treks and enhance the scenic beauty of the fort and surrounding landscapes."
  },
  {
    "title": "Historical Plaques and Exhibits",
    "description": "Purandar Fort features several plaques, inscriptions, and remnants of Maratha-era architecture, providing historical context for visitors interested in learning about battles, fortifications, and local legends."
  },
  {
    "title": "Sunrise and Sunset Points",
    "description": "The fort’s elevated vantage points offer spectacular sunrise and sunset views. Photographers and travelers alike flock here to capture the golden light over the Sahyadri hills, the valleys below, and the distant villages."
  },
  {
    "title": "Nature Walks and Birdwatching",
    "description": "The forested areas around Purandar Fort are home to a variety of birds and wildlife. Nature enthusiasts can enjoy walks, photography, and birdwatching while exploring the natural beauty surrounding the historic fort."
  }
]
,



"services": [
{
"name": "Bus On Rent in Purandar",
"description": "Bus On Rent in Purandar provides reliable and comfortable bus services for local travel, sightseeing tours, family outings, and religious trips. With well-maintained buses, professional drivers, and flexible itineraries, it ensures a safe, punctual, and hassle-free travel experience. Perfect for tourists, corporate groups, school trips, and wedding parties, this service focuses on passenger comfort, convenience, and delivering a smooth journey across Purandar and nearby regions."
},
{
"name": "Bus Hire Purandar",
"description": "Bus Hire Purandar offers flexible and affordable bus rental services for group travel, sightseeing, corporate events, weddings, and school excursions. Spacious seating, modern interiors, and professional drivers ensure passengers enjoy a safe, comfortable, and enjoyable journey. Transparent pricing, organized scheduling, and excellent customer service make it a preferred choice for families, tourists, and organizations traveling in and around Purandar."
},
{
"name": "AC Bus Purandar",
"description": "AC Bus Purandar provides a cool and comfortable travel experience with fully air-conditioned buses. Perfect for long-distance trips, family tours, corporate travel, and sightseeing excursions, these buses offer smooth rides, relaxing interiors, and a premium travel experience for passengers exploring Purandar and surrounding areas."
},
{
"name": "Luxury Bus Purandar",
"description": "Luxury Bus Purandar offers high-end buses equipped with modern amenities, including reclining seats, ample legroom, entertainment options, and superior interiors. Ideal for VIP travel, corporate outings, weddings, and leisure trips, it combines elegance, comfort, and professional service to deliver a memorable and stress-free travel experience."
},
{
"name": "Wedding Bus Purandar",
"description": "Wedding Bus Purandar provides dedicated buses for transporting wedding guests, pre-wedding events, and destination weddings. Spacious and well-maintained vehicles, along with professional drivers, ensure safe, timely, and comfortable transportation, making it convenient for families and friends attending wedding celebrations in and around Purandar."
},
{
"name": "Corporate Bus Purandar",
"description": "Corporate Bus Purandar offers organized transportation solutions for businesses, including office trips, conferences, team outings, and client visits. With experienced drivers, comfortable buses, and punctual service, it ensures smooth and efficient corporate travel in Purandar and nearby regions, focusing on professionalism and reliability."
},
{
"name": "Outstation Bus Purandar",
"description": "Outstation Bus Purandar specializes in long-distance travel to nearby cities, tourist destinations, and hill stations. Comfortable buses, skilled drivers, and flexible itineraries provide safe, convenient, and enjoyable journeys for families, groups, and solo travelers venturing beyond Purandar."
},
{
"name": "Affordable Bus Purandar",
"description": "Affordable Bus Purandar delivers budget-friendly bus services without compromising on comfort or safety. Ideal for families, school trips, corporate groups, and religious tours, it combines economical pricing with well-maintained buses and professional drivers, making it a reliable and convenient choice for cost-conscious travelers."
},
{
"name": "Chauffeur Driven Bus Purandar",
"description": "Chauffeur Driven Bus Purandar provides professional drivers who efficiently handle navigation, traffic, and schedules, allowing passengers to relax throughout their journey. Perfect for family trips, corporate travel, group tours, and special events, it ensures a stress-free, smooth, and enjoyable travel experience."
},
{
"name": "Best Bus Service Purandar",
"description": "Best Bus Service Purandar is known for punctual pickups, clean and well-maintained buses, and excellent customer support. Suitable for weddings, family trips, corporate travel, and tourist excursions, it guarantees safe, comfortable, and reliable transportation with professional drivers for an enjoyable journey every time."
},
{
"name": "Tourist Bus Purandar",
"description": "Tourist Bus Purandar caters to travelers exploring Purandar and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable seating, it provides a memorable sightseeing experience, allowing tourists to enjoy cultural, historical, and scenic sites without worrying about logistics or navigation."
},
{
"name": "Group Travel Bus Purandar",
"description": "Group Travel Bus Purandar offers organized transportation for large groups such as families, friends, school trips, and corporate teams. Spacious buses, coordinated planning, and professional drivers ensure safe, comfortable, and timely travel, making group trips smooth, hassle-free, and enjoyable."
},
{
"name": "Online Bus Booking Purandar",
"description": "Online Bus Booking Purandar allows travelers to reserve buses quickly and conveniently with instant confirmation. Multiple bus options, transparent pricing, and flexible schedules simplify travel planning for families, corporate clients, and tourists visiting Purandar and surrounding regions."
},
{
"name": "Event Bus Purandar",
"description": "Event Bus Purandar provides dedicated bus services for weddings, corporate events, parties, exhibitions, and other special occasions. Comfortable buses, professional drivers, and timely service ensure smooth and organized travel for guests attending events in Purandar and nearby areas."
},
{
"name": "Purandar Travel Bus",
"description": "Purandar Travel Bus offers comprehensive travel solutions for local sightseeing, outstation trips, corporate travel, and group excursions. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, corporate clients, and groups seeking reliable and convenient bus transportation in and around Purandar."
}
],
"tableData": [
["Bus On Rent in Purandar", "Bus Hire Purandar"],
["AC Bus Purandar", "Luxury Bus Purandar"],
["Wedding Bus Purandar", "Corporate Bus Purandar"],
["Outstation Bus Purandar", "Affordable Bus Purandar"],
["Chauffeur Driven Bus Purandar", "Best Bus Service Purandar"],
["Tourist Bus Purandar", "Group Travel Bus Purandar"],
["Online Bus Booking Purandar", "Event Bus Purandar"],
["Purandar Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Purandar with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Purandar, perfect for group outings, family trips, school tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Purandar and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Purandar routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Purandar, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Purandar."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Purandar."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Purandar?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Purandar for various travel needs.'
  },
  {
    question: 'How can I book a bus in Purandar?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Purandar?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Purandar?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Purandar routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Purandar?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Purandar and nearby areas.'
  },
  {
    question: 'Is the bus service in Purandar available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Purandar to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Purandar.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Shinde',
    feedback: 'We rented a bus in Purandar from Sanavi Travels — wonderful experience with a comfortable bus and professional service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Laxmi More',
    feedback: 'Sanavi Travels provided a clean and reliable bus rental service in Purandar. Highly recommended!',
    rating: 5
  }
];


















































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Bus On Rent in Purandar - Sanavi Travels",
  "description": "Sanavi Travels offers reliable bus on rent in Purandar for weddings, corporate travel, group tours, events, and outstation trips. Choose from AC, luxury, and chauffeur-driven buses for safe and comfortable travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "39"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Bus On Rent in Purandar | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Purandar with Sanavi Travels for weddings, corporate travel, events, group tours, and outstation journeys. AC, luxury, and chauffeur-driven buses available with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/139.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinpurandar;